export function moveBgX() {
    const _window = this._window;
    const _document = this._document;
    const movementStrength = 50;
    const  width = movementStrength / _window.innerWidth;
    const moveBg = _document.querySelector(".move-bg-x");
    let pageX = 0;
    let newValueX = 0;
    _document.addEventListener("mousemove", (e) => {
        pageX = e.pageX - _window.innerWidth / 2;
        newValueX = width * pageX * -1 - 20;
        moveBg.style.backgroundPosition = `${newValueX}px bottom`;
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/move-bg-x.js